module.exports = __webpack_public_path__ + "media/images/icons/icons_large/50_music-f7f4bbd854e381f6a862230c28460f84.png";